import React from 'react';
import { makeStyles } from '@material-ui/core';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { DefaultButton } from '../Button/Button';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      [theme.breakpoints.up(1200)]: {
        backgroundImage: 'url(/img/creators/testimonial-bg.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        height: '748px',
        padding: '72px 144px 80px',
      }
    },
    avatar: {
      display: 'block',
      width: '120px',
      height: '120px',
      marginBottom: '32px',
      borderRadius: '100%',
      transform: 'translateZ(0)',
    },
    text: {
      color: '#FFF',
      fontSize: '22px',
      lineHeight: '36px',
      fontWeight: '400',
      fontStyle: 'italic',
      textAlign: 'center',
      margin: '0 0 24px',
    },
    author: {
      fontSize: '15px',
      lineHeight: '20px',
      color: '#FFF',
      textAlign: 'center',
      margin: '0 0 40px',
    },
    categories: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      gap: '8px',
      flexWrap: 'wrap',
      marginBottom: '24px',
    },
    category: {
      display: 'block',
      padding: '6px 8px',
      backgroundColor: '#555B71',
      borderRadius: '50px',
      whiteSpace: 'nowrap',
      color: '#FFF',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '400',
    },
    links: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      gap: '8px',
      flexWrap: 'wrap',
      marginBottom: '24px',
    },
    twitterIcon: {
      display: 'block',
      width: '24px',
      height: '24px',
    }
  }
})

const CreatorsTestimonialItem = ({
  avatar,
  text,
  author,
  categories,
  uptimeLink,
  twitterLink,
  linkedinLink,
  youtubeLink,
  instagramLink,
  hackLink,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <GatsbyImage
        className={classes.avatar}
        image={avatar as IGatsbyImageData}
        alt=""
      />
      <p className={classes.text}>
        {text}
      </p>
      <p className={classes.author}>
        {author}
      </p>
      {categories.length > 0 && (
        <div className={classes.categories}>
          {categories.map((category) => {
            return (
              <span key={`${author}-${category}`} className={classes.category}>
                {category}
              </span>
            )
          })}
        </div>
      )}
      {(uptimeLink || twitterLink || linkedinLink || youtubeLink || instagramLink) && (
        <div className={classes.links}>
          {uptimeLink && (
            <a href={uptimeLink} target="_blank" rel="noreferrer noopener">
              <img className={classes.twitterIcon} src="/img/creators/uptime-link.svg" alt="" />
            </a>
          )}
          {twitterLink && (
            <a href={twitterLink} target="_blank" rel="noreferrer noopener">
              <img className={classes.twitterIcon} src="/img/creators/twitter-link.svg" alt="" />
            </a>
          )}
          {linkedinLink && (
            <a href={linkedinLink} target="_blank" rel="noreferrer noopener">
              <img className={classes.twitterIcon} src="/img/creators/linkedin-link.svg" alt="" />
            </a>
          )}
          {youtubeLink && (
            <a href={youtubeLink} target="_blank" rel="noreferrer noopener">
              <img className={classes.twitterIcon} src="/img/creators/youtube-link.svg" alt="" />
            </a>
          )}
          {instagramLink && (
            <a href={instagramLink} target="_blank" rel="noreferrer noopener">
              <img className={classes.twitterIcon} src="/img/creators/instagram-link.svg" alt="" />
            </a>
          )}
        </div>
      )}
      {hackLink && (
        <DefaultButton variant="default" to={hackLink} target="_blank" rel="noreferrer noopener">
          View Hack
        </DefaultButton>
      )}
    </div>
  )
}

export default CreatorsTestimonialItem;
